import { IMAGES } from "../../../constants/images";
import styled from "styled-components";

export default function HeaderOfModal({ handleOpen }) {
  return (
    <HeaderContainer>
      <div className="header">
        <h2>Contact Us</h2>
        <button aria-label="Close modal" onClick={handleOpen}>
          {<img src={IMAGES.CLOSE} alt="Close" />}
        </button>
      </div>
      <p className="introduction-text">
        Fill out this information to discuss a risk
        <br />
        assessment with our experts.
      </p>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  margin-bottom: 20px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h2 {
      margin: 0;
    }
    button {
      all: unset;
      cursor: pointer;
    }
  }
  .introduction-text {
    text-align: center;
    font-size: 18px;
    margin-top: 30px;
    font-weight: 500;
    color: #555;
  }
`;
